import React from "react";
import Button from "../utils/Button";

import { useNavigate } from "react-router";
import useShopStore from "../store/useShopStore";

export default function EditButton(props) {
  const { getProduct } = useShopStore((state) => state);
  const navigate = useNavigate();

  const showUpdateHandler = (id) => {
    getProduct(id);
    navigate("/update");
  };

  return (
    <Button onClick={() => showUpdateHandler(props.id)} type="button">
      Edit
    </Button>
  );
}
